export const Countries = [{
   "Note": "The first digit denotes regions, which are partly identical to one of the nine provinces—called Bundesländer; the last the nearest post office in the area.",
   "Country": "Austria",
   "ISO": "AT",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "43"
}, {
   "Note": "In general, the first digit gives the province.",
   "Country": "Belgium",
   "ISO": "BE",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "32"
}, {
   "Note": "With Slovak Republic, Poštovní směrovací číslo (PSČ) - postal routing number.",
   "Country": "Czech Republic",
   "ISO": "CZ",
   "Format": "000 00",
   "Regex": "^(([0-9]{5})|([0-9]{3}[ ]{0,1}[0-9]{2}))$",
   "PhonePrefix": "420"
}, {
   "Note": "Numbering follows the dispatch of postal trains from Copenhagen.[3] Also used by Greenland, e.g.: DK-3900 Nuuk.",
   "Country": "Denmark",
   "ISO": "DK",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "45"
}, {
   "Note": "Postleitzahl (PLZ), introduced after the German reunification. Between 1989 and 1993 the old separate 4-digit postal codes of former West- and East-Germany were distinguished by preceding \"W-\" or \"O-\" ('Ost' for East).",
   "Country": "Germany",
   "ISO": "DE",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "49"
}, {
   "Note": "https://rgxdb.com/r/354H8M0X",
   "Country": "France",
   "ISO": "FR",
   "Format": "00000",
   "Regex": "^(?:0[1-9]|[1-8]\\d|9[0-8])\\d{3}$",
   "PhonePrefix": "33"
}, {
   "Note": "First two indicate the province, range 01-52",
   "Country": "Spain",
   "ISO": "ES",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "34"
}, {
   "Note": "https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes",
   "Country": "United Kingdom",
   "ISO": "GB",
   "Format": "****[ ]***",
   "Regex": "^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})$",
   "PhonePrefix": "44"
}, {
   "Note": "https://regex101.com/library/mS4fO6",
   "Country": "Ireland",
   "ISO": "IE",
   "Format": "a00 ****",
   "Regex": "^([AC-FHKNPRTV-Y]{1}[0-9]{2}|D6W)[ ]?[0-9AC-FHKNPRTV-Y]{4}$",
   "PhonePrefix": "353"
}, {
   "Note": "https://rgxdb.com/r/4W9GV8AC",
   "Country": "Netherlands",
   "ISO": "NL",
   "Format": "0000 aa",
   "Regex": "^(?:NL-)?(\\d{4})\\s*([A-Z]{2})$",
   "PhonePrefix": "31"
}, {
   "Note": "https://en.wikipedia.org/wiki/Postal_codes_in_Poland",
   "Country": "Poland",
   "ISO": "PL",
   "Format": "00-000",
   "Regex": "^[0-9]{2}[-]([0-9]){3}$",
   "PhonePrefix": "48"
}, {
   "Note": "Previously 99999 in Bucharest and 9999 in rest of country.",
   "Country": "Romania",
   "ISO": "RO",
   "Format": "000000",
   "Regex": "^\\d{6}$",
   "PhonePrefix": "40"
}, {
   "Note": "",
   "Country": "Sweden",
   "ISO": "SE",
   "Format": "000 00",
   "Regex": "^[0-9]{3}\\s?[0-9]{2}$",
   "PhonePrefix": "46"
}, {
   "Note": "",
   "Country": "Slovenia",
   "ISO": "SI",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "386"
}, {
   "Note": "",
   "Country": "Slovakia",
   "ISO": "SK",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "421"
}, {
   "Note": "",
   "Country": "Switzerland",
   "ISO": "CH",
   "Format": "0000",
   "Regex": "^[1-9]\\d{3}$",
   "PhonePrefix": "41"
}, {
   "Note": "",
   "Country": "Italy",
   "ISO": "IT",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "39"
}, {
   "Note": "",
   "Country": "Norway",
   "ISO": "NO",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "47"
}, {
   "Note": "Postal codes in Finland consist of 5 digits. The first two digits indicate the region.",
   "Country": "Finland",
   "ISO": "FI",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "358"
}, {
   "Note": "First two digits represent provinces (01-11).",
   "Country": "Bulgaria",
   "ISO": "BG",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "359"
}, {
   "Note": "First two digits indicate the district.",
   "Country": "Croatia",
   "ISO": "HR",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "385"
}, {
   "Note": "First digit represents the region, introduced in 2004.",
   "Country": "Cyprus",
   "ISO": "CY",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "357"
}, {
   "Note": "First two digits indicate the county (maakond).",
   "Country": "Estonia",
   "ISO": "EE",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "372"
}, {
   "Note": "First two or three digits indicate the prefecture, range 100-999.",
   "Country": "Greece",
   "ISO": "GR",
   "Format": "000 00",
   "Regex": "^\\d{3}[ ]?\\d{2}$",
   "PhonePrefix": "30"
}, {
   "Note": "First digit indicates the region.",
   "Country": "Hungary",
   "ISO": "HU",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "36"
}, {
   "Note": "Format includes optional routing key prefix. First digit indicates geographic region.",
   "Country": "Iceland",
   "ISO": "IS",
   "Format": "000",
   "Regex": "^\\d{3}$",
   "PhonePrefix": "354"
}, {
   "Note": "First two digits indicate the administrative division.",
   "Country": "Latvia",
   "ISO": "LV",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "371"
}, {
   "Note": "Introduced in 2005.",
   "Country": "Lithuania",
   "ISO": "LT",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "370"
}, {
   "Note": "",
   "Country": "Luxembourg",
   "ISO": "LU",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "352"
}, {
   "Note": "Three-letter area codes followed by four digits.",
   "Country": "Malta",
   "ISO": "MT",
   "Format": "aaa 0000",
   "Regex": "^[A-Z]{3}[ ]?\\d{4}$",
   "PhonePrefix": "356"
}, {
   "Note": "First two digits indicate the administrative region.",
   "Country": "Moldova",
   "ISO": "MD",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "373"
}, {
   "Note": "All Monaco postal codes start with 980.",
   "Country": "Monaco",
   "ISO": "MC",
   "Format": "98000",
   "Regex": "^980\\d{2}$",
   "PhonePrefix": "377"
}, {
   "Note": "Introduced in 2004.",
   "Country": "Montenegro",
   "ISO": "ME",
   "Format": "00000",
   "Regex": "^\\d{5}$",
   "PhonePrefix": "382"
}, {
   "Note": "North Macedonia uses 4-digit postal codes.",
   "Country": "North Macedonia",
   "ISO": "MK",
   "Format": "0000",
   "Regex": "^\\d{4}$",
   "PhonePrefix": "389"
}, {
   "Note": "First four digits indicate the district.",
   "Country": "Portugal",
   "ISO": "PT",
   "Format": "0000-000",
   "Regex": "^\\d{4}[-]?\\d{3}$",
   "PhonePrefix": "351"
}, {
   "Note": "First three digits indicate the delivery post office. Can be 5 or 6 digits.",
   "Country": "Serbia",
   "ISO": "RS",
   "Format": "000000",
   "Regex": "^\\d{5,6}$",
   "PhonePrefix": "381"
}]